import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { formatNumber, formatNumberToB, isNullOrEmpty } from '../helpers/utils';

export default memo(function BoxChartBottom(props) {
    const { t } = useTranslation();

    return (
        <div className="boxchart__bot font-weight-500">
            <div className="flex__center exchange-info">
                <div>{formatNumber(props.total_volume)} {t("cpShares")}</div>
                <div style={{ width: "0.5rem" }}></div>
                <div>{formatNumberToB(props.total_value)} {t("ty")}</div>
            </div>
            <div className="flex__center">
                <div className="d-flex nowrap">
                    <div className="listitemnb mgr-5p">
                        <div className="cl_gr"><img src="/static/img/icon/icon-gr-up.svg" alt="img" />{props.up}</div>
                    </div>
                    <div className="listitemnb mgr-5p">
                        <div className="cl_violet">({props.up_ceil})</div>
                    </div>
                    <div className="listitemnb mgr-5p">
                        <div className="cl_yl"><img src="/static/img/icon/icon-bl-yl.svg" alt="img" />{props.nochange}</div>
                    </div>
                    <div className="listitemnb mgr-5p">
                        <div className="cl_red"><img src="/static/img/icon/icon-down.svg" alt="img" />{props.down}</div>
                    </div>
                    <div className="listitemnb mgr-5p">
                        <div className="cl_blue">({props.down_floor})</div>
                    </div>
                </div>
                <div className='nowrap'>
                    {/* {props.status_str} */}
                    {!isNullOrEmpty(props.status) ? t("indexStatus_" + props.status) : "-"}
                </div>
            </div>
        </div>
    )
});
